






















































import Vue from 'vue';
import axios from 'axios';
import { ReportSpecByWeek } from '@/components/ReportControls.vue';
import Vue2Filters from 'vue2-filters';
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiAutorenew } from '@mdi/js';

Vue.use(Vue2Filters);

export default Vue.extend({
  name: 'DailyVolumePrediction',
  components: {
    SvgIcon,
  },
  props: {
    spec: Object as () => ReportSpecByWeek,
  },
  data() {
    return {
      path: mdiAutorenew,
      size: 48,
      loading: true,
      data: {},
    };
  },
  computed: {
    dataUrl(): string {
      const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';
      const {depot} = this.spec;
      return `${BASE_URL}/reports/daily-volume-prediction/${depot}/`;
    },
  },
  watch: {
    spec: {
      immediate: true,
      async handler() {
        const response = await axios.get<{ values: { [ time: string ]: number } }>(this.dataUrl);
        this.data = response.data.values;
        this.loading = false;
      },
    },
  },
});
